import React from "react";
import { Link, Outlet } from "react-router-dom";
import Logo from "../../assets/Opensource-02.jpg";
import "./ratingLayout.css";

const RatingsLayout = () => {
  return (
    <>
      <header className="ratings-navbar">
        <div className="logo">
          <Link to={"/"}>
            <img src={Logo} alt="Logo" />
          </Link>
        </div>
      </header>
      <main className="ratings-main">
        <Outlet />
      </main>
    </>
  );
};

export default RatingsLayout;
